import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import CustomDialog from '../../../components/common/CustomDialog/CustomDialog'
import {
  StyledConfirmationDialogButton,
  StyledConfirmationWarningIcon,
  StyledContentBox,
  StyledDialogTitle,
  StyledFlexBox
} from './UseCaseStyles'

const ConfirmationDialog = ({showDialog, selectedUseCases, handleConfirm, handleClose}) => {
  const useCasesText = selectedUseCases.length > 1 ? 'use cases' : 'use case'

  const title = (
    <StyledFlexBox>
      <StyledConfirmationWarningIcon />
      <StyledDialogTitle variant='titleMedium'>Are you sure you want to remove the filter ?</StyledDialogTitle>
    </StyledFlexBox>
  )

  const content = (
    <StyledContentBox>
      Removing this filter will eliminate the <b>{selectedUseCases.join(', ')}</b> {useCasesText} from this project, as
      the filter is associated with that {useCasesText}.
    </StyledContentBox>
  )

  const footer = (
    <Box>
      <br />
      <StyledFlexBox>
        <StyledConfirmationDialogButton buttonType='cancel' onClick={handleClose}>
          Cancel
        </StyledConfirmationDialogButton>
        <StyledConfirmationDialogButton buttonType='confirm' onClick={handleConfirm}>
          Confirm
        </StyledConfirmationDialogButton>
      </StyledFlexBox>
    </Box>
  )

  return (
    <Box>
      {showDialog && (
        <CustomDialog
          size='sm'
          isOpened={showDialog}
          title={title}
          content={content}
          footer={footer}
          underlineTitle={false}
          handleClose={handleClose}
        />
      )}
    </Box>
  )
}

ConfirmationDialog.propTypes = {
  showDialog: PropTypes.bool,
  selectedUseCases: PropTypes.array,
  handleConfirm: PropTypes.func,
  handleClose: PropTypes.func
}

export default ConfirmationDialog
